import { Card, CardContent } from "@mui/material";
import { Button } from "@mui/material";
import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React, { useEffect, useState } from "react";
import { FaGlobe } from "react-icons/fa";
import { Link } from "react-router-dom";

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

const KundliInfo = ({ language }) => {
  console.log(language);
  const sections = [
    {
      title: {
        hindi: "घर बैठे ले परामर्श",
        english: "Now One Can Have Advice at Home",
      },
      content: {
        hindi:
          (
            <>
              "भगवान श्री महाकालेश्वर की पावन नगरी उज्जैन में स्थित श्री महामाया ज्योतिष केन्द्र लेकर आया है, इस समस्या का समाधान आपके द्वार। आप घर बैठे ही वंश परंपरागत व ज्योतिष में उच्चस्तरीय शिक्षा प्राप्त विद्वान ज्योतिषाचार्य ‘’विधु’’ के उपनाम से खयात पं. अखिलेश्‍वर शर्मा के मार्गदर्शन में विशेषज्ञ ज्‍योतिषाचार्यों से परामर्श प्राप्त कर सकते हैं। इसमें आपकी समस्त वर्ग कुण्डलियों की गहन व सुक्ष्मतम विवेचना की जाऐगी। इसमें परामर्श प्राप्त करने का माध्यम चुनने की भी आपको स्वतंत्रता होगी। आप चाहें तो अप्वाईनमेंट लेकर आचार्यजी से फोन पर परामर्श ले सकते हैं और यदि आप चाहें तो ई-मेल द्वारा भी आप अपने प्रश्‍नों का समाधान प्राप्त कर सकते हैं। इससे आपका बेश कीमती समय भी बचेगा और आप प्राप्‍त कर सकेंगे देश ही नहीं दुनियॉं के किसी भी कोने से घर बैठे परामर्श।<b>परामर्श हेतु भारत में शुल्क ₹1100 तथा विदेश से परामर्श लेने वाले व्यक्तियों के लिए शुल्क $15 (USD)</b> निर्धारित किया गया है, जिसे <b><u>अग्रिम रूप से भुगतान करना अनिवार्य होगा।</u></b>"
            </>
          ),
        english:
          (
            <>
            Shri Mahamaya Jyotish Kendra, located in the sacred city of Lord Shri Mahakaleshwar – Ujjain, brings the solution to your problems right at your doorstep. While sitting at home, you can receive guidance from expert astrologers under the supervision of renowned astrologer Pt. Akhileshwar Sharma, famously known by the title “Vidhu”, who belongs to a lineage of traditional astrology and holds high-level education in the field.All your horoscope charts will be deeply and minutely analyzed. You also have the freedom to choose your preferred mode of consultation. You may take an appointment and consult Acharyaji over the phone, or if you wish, you can also get answers to your queries via email. This will save your precious time and allow you to receive consultation from any corner of the country or even the world, right from your home. For horoscope consultation, <b>the charges are ₹1100 within India and $15 (USD) for clients abroad</b>, and <b><u>advance payment is mandatory</u></b>.
            </>
          )
      },
      image: "💬",
    },
    {
      title: {
        hindi: "कैसे लें परामर्श",
        english: "How to Seek Advice from our Astrologer",
      },
      content: {
        hindi: (
          <>
            आपकी समस्याओं के समाधान के लिए ज्योतिष कार्यालय द्वारा ही आचार्यजी
            के मार्गदर्शन में जन्म पत्रिका का निर्माण किया जाएगा। इसी के आधार पर
            आचार्यजी परामर्श प्रदान करेंगे। इसके लिये निम्न जानकारी देनी होगी.
            <ul className="list-decimal pl-6 mt-2 text-wrap font-bold">
              <li>पूरा नाम, पता व सम्पर्क नम्बर</li>
              <li>जन्म स्थान, जन्म दिनांक व जन्म समय</li>
              <li>
                यदि समस्या समाधान के लिये पत्र लिख रहे हैं तो पत्र लिखने का
                स्थान, दिनांक व समय
              </li>
              <li>आपके प्रश्‍न अधिकतम तीन व परामर्श प्राप्त करने का माध्यम</li>
            </ul>
            <span className="text-sm text-red-400">
              नोटः-यदि आप चाहें तो अपनी तैयार जन्म-पत्रिका की  प्रति  भी
              प्रेषित कर सकते हैं।
            </span>
          </>
        ),
        english: (
          <>
            To remedy your problems, a detailed horoscope will be prepared by
            the office under the guidance of Acharya Akhileshji Sharma. You need
            to send in the following information on the basis of which Acharyaji
            will give you advice:
            <ul className="list-decimal pl-6 mt-2 text-wrap font-bold">
              <li>Full Name, Address and contact Numbers</li>
              <li>Place of birth, birth date and birth time</li>
              <li>
                Date and time of writing (if writing a letter for the solution
                of your problem)
              </li>
              <li>Maximum three question in clear word</li>
            </ul>
            <span className="text-sm text-red-400">
              Note:- You may send your horoscope also.
            </span>
          </>
        ),
      },
      image: "📝",
    },
    {
      title: {
        hindi: "त्‍वरित कुण्‍डली मिलान",
        english: "Genuine Horoscope Matching",
      },
      content: {
        hindi:
          "विवाह जीवन के सुख व सफलता की सीढ़ी है। अपनी व्यस्तताओं या अज्ञानता के कारण कुण्डली मिलान न करवाना जीवन की कई समस्याओं को जन्म देता है। कुण्डली मिलान मेंमंगलदोष, षडाष्टक,  नाड़ी दोष आदि कई स्थितियॉं निर्मित होती हैं, जिनमें सामान्य ज्योतिषी उनकी विवेचना नहीं कर पाते और एक नजर में ही उन्हें दोष बता देते हैं। हमारे मनीषियों ने अपने ग्रंथों में इनकी विस्तृत विवेचना की है। इनके अनुसार कई बार अन्य ग्रहों की अनुकूल स्थितियों से इन दोषों का परिहार ही हो जाता है और ये दोष कुण्डली में प्रभावी रहते ही नहीं। इस तरह अज्ञानता वश अच्छे रिश्‍ते भी हाथ से निकल जाते हैं। इसी का समाधान हम घर बैठे ही दे रहे हैं। इसके लिये वर-वधु केनाम, जन्म दिनांक, जन्म स्थान व जन्म समय की जानकारी देना अनिवार्य है। कई बार कुण्डली मिलान में देरी से भी अच्छे रिश्‍ते हाथ से निकल जातेहैं। अतः इसे प्राथमिकता देते हुऐ प्रयास यह रहेगा कि वर-वधु की जानकारी प्राप्त होते ही यथा शीघ्र उसी दिन कुण्डली मिलान किया जा सके।",
        english:
          "Marriage is the step to a happy and successful life. Not matching horoscope because of pre-occupation or ignorance creates a good deal of problem in life. Certain situations e.g. ‘Shadashtak’, ‘Mangal’ or ‘gene related demerits’ occur in the process of matching them that render an average astrologer unfit for their analysis and pass a verdict at a cursory glance. Our great scholars have critically appreciated them. According to them these planetary or other demerits can be eradicated making them ineffective. Resultantly, good relations slip off our hands. We are remedying the same at your home. To this end, you need to inform the names of the girl and the boy in question and their time, date and place of birth. At certain occasions, a delay in matching horoscopes deprives one of good relations. It will be, therefore, our sincere effort to match horoscopes on priority basis as far as possible.",
      },
      image: "💑",
    },
    {
      title: {
        hindi: "जन्‍म समय ज्ञात न होने पर भी ज्‍योतिष परामर्श",
        english: "Astrological consultation even without knowing the exact time of birth.",
      },
      content: {
        hindi: (
          <>
            जब जन्म समय की जानकारी न हो तो सटीक ज्योतिषीय परामर्श ले पाना संभव नहीं हो पाता। इनका समाधान प्रश्न कुण्डली, अंकज्योतिष, हस्तरेखा के माध्यम से किया जा सकता है। अतः आप आपकी जन्म-पत्रिका न होने पर या सही जन्म समय की जानकारी न होने की स्थिति में भी ज्योतिष परामर्श का लाभ ले सकते हैं। इसके लिये आपको पहुंचानी होगी निम्नजानकारी:
            <ul className="list-decimal pl-6 mt-2 text-wrap font-bold">
              <li>प्रश्न पूछने या लिखने का दिनॉंक, समय व स्थान</li>
              <li>अपना पूर्ण नाम</li>
              <li>जन्म दिनांक</li>
              <li>
                ट्रेसिंग पेपर पर स्याही या रंग से अपने दोनों हाथों की स्पष्ट
                प्रिन्ट
              </li>
              <li>आपके प्रश्न अधिकतम तीन</li>
            </ul>
          </>
        ),
        english: (
          <>
            If you have no information about the time of birth, then it is
            impossible to find it out correctly by astrological means. It can be
            solved by the method of a ‘Question Horoscope’ or ‘Numerology’,
            ‘Manuscript’ and by their combined analysis. You may, therefore have
            the benefit of astrological advice in absence of your horoscope and
            the right time of birth. For this you will have to furnish the
            following information as possible:
            <ul className="list-decimal pl-6 mt-2 text-wrap font-bold">
              <li>The time and place of asking the question</li>
              <li>Full Name</li>
              <li>Date of birth</li>
              <li>Clear print in ink/ color of the lines of your palms </li>
              <li>Maximum three questions</li>
            </ul>
          </>
        ),
      },

      image: "⏳",
    },
    {
      title: {
        hindi: "पारिवारिक पंडित योजना",
        english: "Family Astrologer Plan",
      },
      content: {
        hindi:
          "कुण्डली मिलान में बार- बार व तत्काल भी ज्योतिष परामर्ष प्राप्त करने की आवश्‍यकता होती है। इसके लिये हम आये हैं, पारिवारिक पंडित योजना। यदि आप चाहें तो इसे भी अपना सकते हैं। इसके अन्तर्गत आप मात्र 5100 रु. व विदेशों के लिये 65 यूएस डॉलर परामर्श शुल्क एक बार चुकाकर एक वर्ष की अवधि में 11 बार कुण्डली मिलान करवा सकते हैं। इसके लिये भी अप्वाईनमेंट तो लेना होगा लेकिन यथासम्भव उसी दिन भी परामर्श प्रदान किया जा सकेगा। यह सेवा सिर्फ कुण्डली मिलान के लिये ही दी जासकेगी।",
        english:
          "To match horoscopes immediate and repeated astrological advice is necessary. One May opt for a very convenient plan as well. The plan facilitates one to match horoscopes 11 times in a year on payment of Rs.5100/- (65 US $ for foreign countries) as consultation fees. One has to make an appointment; consultation is also possible the same day.",
      },
      image: "👨‍👩‍👧‍👦",
    },
    {
      title: {
        hindi: "वास्तु परामर्श",
        english: "Architectural Advice",
      },
      content: {
        hindi: (
          <>
            यदि आप नवीन मकान, दुकान या उद्योग के भवन का निर्माण कर रहे हैं या परेशानियों का सामना कर रहे हैं, सुख समृद्धि के लिये वास्तु परामर्श लेना आवश्यक है। याद रखें छोटा सा वासतु दोष भी आपके सपनों को चकनाचूर कर सकता है। इसके लिये परामर्ष शुल्क मात्र{" "}
            <span className="font-bold">11000 रु.</span> व विदेषों के लिये{" "}
            <span className="font-bold">125 USD</span> के साथ निम्न जानकारी
            प्रेषित करें.
            <ul className="list-decimal pl-6 mt-2 text-wrap font-bold">
              <li>भवन का विस्तृत नक्षा (भवन की आंतरिक व्यवस्था भी दर्षाऐं)</li>
              <li>भवन स्वामी का नाम, जन्म स्थान, जन्म दिनांक व जन्म समय</li>
              <li>वर्तमान में आ रही समस्याऐं</li>
            </ul>
          </>
        ),
        english: (
          <>
            If you are constructing or have already built a new house, a shop or
            an industry and are facing dangers. You may attribute them to
            architectural defects. Consultation in the matter is necessary. You
            have to remit the sum of{" "}
            <span className="font-bold">
              Rs.11000/-(125 US $ for foreign countries)
            </span>{" "}
            as the consultation fees. To avail of this facility furnish the
            following information with consultation fees:
            <ul className="list-decimal pl-6 mt-2 text-wrap font-bold">
              <li>A detailed Map of the Building (Indicating the Interiors)</li>
              <li>Name of owner,The time, date and place of birth of owner </li>
              <li>Current problems </li>
            </ul>
          </>
        ),
      },
      image: "🏠",
    },
    {
      title: {
        hindi: "भगवान महाकालेश्‍वर की नगरी उज्‍जैन में पूजा का लें लाभ",
        english: "Take advantage of worship in the city of Lord Mahakaleshwar, Ujjain.",
      },
      content: {
        hindi:
          "आप उज्‍जैन में हों या देश – विदेश के किसी भी स्‍थान पर आप चाहें तो उज्‍जैन के विद्वान पंडितों के माध्‍यम से पूजा करवाने का भी हम आपको आसान सुअवसर दे रहे हैं। इसके अंतर्गत आप निर्धारित शुल्‍क का भुगतान कर प्रत्‍यक्ष अथवा ऑनलाईन पूजा करवा सकते हैं। ऑनलाईन पूजा के लिये भी आपका पूजा के समय विडियो कॉल पर उपस्थित रहकर निर्देशों का पालन करना अनिवार्य होगा।  ",
        english:
          "Whether you are in Ujjain or anywhere else in the country or abroad, we are offering you an easy and convenient opportunity to have worship rituals performed by learned priests from Ujjain. Under this service, you can pay the prescribed fee and get the rituals performed either in person or online. For online worship, it is mandatory for you to be present via video call at the time of the ritual and follow the instructions given.",
      },
      image: "🛕",
    },
  ];
 

  return (
    <div className="p-4 max-w-3xl mx-auto">
      


      <h1 className="text-3xl font-bold text-center mb-4 mt-2 text-black">
        {language === "hindi"
          ? "📜 कुण्डली परामर्श"
          : "📜Horoscope consultation"}
      </h1>

      {sections.map((section, index) => (
        <Accordion
          key={index}
          className="mb-3 border border-blue-200 rounded-lg"
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <h3 className="font-bold text-lg text-center">
              {section.title[language]}
            </h3>
          </AccordionSummary>
          <AccordionDetails>
            <Card className="my-2 shadow-lg border border-gray-200">
              <CardContent>
                <div className="flex flex-col items-center">
                  <img
                    src={`https://emojicdn.elk.sh/${section.image}`}
                    alt={section.title[language]}
                    className="w-32 h-32 object-cover rounded-lg mb-3"
                  />
                  <p className="text-lg text-center">
                    {section.content[language]}
                  </p>
                </div>
              </CardContent>
            </Card>
          </AccordionDetails>
        </Accordion>
      ))}
      <div className="mt-8 sm:mt-12 text-center">
        <p className="text-xl font-semibold text-yellow-800">
          {language === "hindi"
            ? "मार्गदर्शन के लिए हमारे ज्योतिषी से मिलें"
            : "For guidance, meet our astrologer"}
        </p>

        <div className="mt-4 flex flex-col items-center">
          <Link to="/contact">
            <button
              className="bg-yellow-500 hover:bg-yellow-600 text-black font-bold py-2 px-6 rounded-full shadow-lg transition-all duration-300 text-lg"
              onClick={scrollToTop}
            >
              {language === "hindi" ? "संपर्क करें" : "Contact Us"}
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default KundliInfo;
